import {
  EditFilled,
  MinusOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Button, Space } from 'antd';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonDeleteConfirm,
  type ButtonDeleteConfirmProps,
} from './ButtonDeleteConfirm.tsx';

export interface IContentHoverActionButtonsProps {
  onEdit?: React.MouseEventHandler<HTMLElement>;
  onAdd?: React.MouseEventHandler<HTMLElement>;
  onRemove?: React.MouseEventHandler<HTMLElement>;
  onConfig?: React.MouseEventHandler<HTMLElement>;
  confirmRemove?: boolean;
  confirmRemoveProps?: Omit<ButtonDeleteConfirmProps, 'onConfirm'>;
  extraActions?: React.ReactNode;
}

export function ContentHoverActionButtons({
  onEdit,
  onAdd,
  onRemove,
  onConfig,
  confirmRemove,
  confirmRemoveProps,
  extraActions,
}: IContentHoverActionButtonsProps) {
  const { t } = useTranslation();
  return (
    <Space>
      {onRemove &&
        (confirmRemove ? (
          <ButtonDeleteConfirm
            {...confirmRemoveProps}
            buttonProps={{
              'aria-label': t('button.content-hover-delete', 'Elimina'),
              ...confirmRemoveProps?.buttonProps,
            }}
            size="middle"
            onConfirm={onRemove}
          />
        ) : (
          <Button
            icon={<MinusOutlined aria-hidden="true" />}
            onClick={onRemove}
            aria-label={t('button.content-hover-delete', 'Elimina')}
          />
        ))}
      {onEdit && (
        <Button
          type="primary"
          icon={<EditFilled aria-hidden="true" />}
          onClick={onEdit}
        >
          {t('button.content-hover-edit', 'Modifica')}
        </Button>
      )}
      {onAdd && (
        <Button
          icon={<PlusOutlined aria-hidden="true" />}
          onClick={onAdd}
          aria-label={t('button.content-hover-add', 'Aggiungi')}
        />
      )}
      {onConfig && (
        <Button
          icon={<SettingOutlined aria-hidden="true" />}
          onClick={onConfig}
          aria-label={t('button.content-hover-config', 'Configura')}
        />
      )}
      {extraActions}
    </Space>
  );
}
